import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Checkbox, FormControlLabel, Typography, Divider } from '@mui/material';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import { get, sequence } from '@totalsoft/change-tracking-react';
import { FakeText } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';

const AssetEquipmentComponent = ({ equipmentLens, onSelectEquipment, loading, readOnly }) => {
  const { t } = useTranslation();

  return loading ? (
    <FakeText lines={3} />
  ) : (
    equipmentLens && (equipmentLens |> sequence).length > 0 && (
      <Grid container spacing={1} mt={2}>
        <Grid item xs={12}>
          <Typography fontWeight='bold'>{t('Offer.Edit.Asset.SafetyPackages')}</Typography>
          <Divider sx={{ my: 1 }} />
        </Grid>
        {(equipmentLens |> sequence).map((equipment, index) => (
          <Grid item xs={4} key={index}>
            <FormControlLabel
              control={
                <Checkbox
                  id={'ASSET_EQUIPMENT_' + index}
                  disabled={readOnly}
                  checked={Boolean(equipment.selected |> get)}
                  onChange={onCheckBoxChange(onSelectEquipment(index)('selected'))}
                />
              }
              label={equipment.name |> get}
            />
          </Grid>
        ))}
      </Grid>
    )
  );
};

AssetEquipmentComponent.propTypes = {
  equipmentLens: PropTypes.object,
  onSelectEquipment: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  readOnly: PropTypes.bool.isRequired
};
export default AssetEquipmentComponent;
